// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 70) return "js/70-b97387f039afc51d.js";
  // return url for filenames based on template
  return "js/" + ({592: "logrocket",712: "echarts",}[chunkId] || chunkId) + "-" + {250: "e25c0c43a2471582",43: "e6d78e8b11c02f6c",578: "380a9a030ae91cf1",580: "c7a9d507dbd8a77b",592: "391a9ca13585c76e",696: "fbf70650460e9d8d",712: "6aab10c7fd6cfc28",}[chunkId] + ".chunk.js"
}